import { DialogTitle, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const StyledModalTitle = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.grey[900],
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '36px',
  textAlign: 'center',
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  color: theme.palette.grey[300],
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '16px',
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  cursor: 'pointer',
}));
